import { render, staticRenderFns } from "./IncidentApprovalHistory.vue?vue&type=template&id=4ddf95a7&"
import script from "./IncidentApprovalHistory.vue?vue&type=script&lang=js&"
export * from "./IncidentApprovalHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports